/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    'Brak zmiennych VITE_SUPABASE_URL lub VITE_SUPABASE_ANON_KEY. ' +
    'Upewnij się, że plik .env istnieje i serwer został zrestartowany (npm run dev).'
  )
}

export const supabase = createClient(supabaseUrl, supabaseKey)

export interface GalleryAlbum {
  id: string
  name: string
  description: string
  cover_image_url: string
  created_at: string
}

export interface GalleryImage {
  id: string
  image_url: string
  caption: string
  album_id: string | null
  created_at: string
}
